import React, { memo } from 'react';
import classNames from 'classnames';
import { Progress, Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral, getLiteralWithParameters } from 'utils/getLiteral';
import { useMarketingCampaignLimits } from '../../hooks/useMarketingCampaignLimits';

import './styles.scss';

function MarketingCampaignUsageWidget() {
    const theme = useTheme();
    const { viewModel, loading, error } = useMarketingCampaignLimits();

    if (loading || error || !viewModel) {
        return null;
    }

    return (
        <div className="marketing-campaign-usage-widget">
            <div className="marketing-campaign-usage-widget__header">
                <Text type="caption">
                    {getLiteralWithParameters(
                        viewModel.dailyUsageLiteralKey,
                        viewModel.dailyUsageLiteralParams,
                    )}
                </Text>
                <Text type="caption">{`${viewModel.dailyPercentage}%`}</Text>
            </div>

            <Progress
                value={viewModel.dailyProgressValue}
                max={viewModel.dailyProgressMax}
                className={classNames({
                    'marketing-campaign-usage-widget__progress--warning':
                        viewModel.isDailyUsageHigh,
                })}
            />

            <Text
                type="caption"
                color={theme.colors.utility.textSecondary}
                className="marketing-campaign-usage-widget__monthly-limit"
            >
                {getLiteralWithParameters(
                    viewModel.monthlyLimitLiteralKey,
                    viewModel.monthlyLimitLiteralParams,
                )}
            </Text>

            {viewModel.blockingMessageKey && (
                <Text
                    type="caption"
                    color={theme.colors.semantic.caution600}
                    className="marketing-campaign-usage-widget__blocking-message"
                >
                    {getLiteral(viewModel.blockingMessageKey)}
                </Text>
            )}
        </div>
    );
}

MarketingCampaignUsageWidget.displayName = 'MarketingCampaignUsageWidget';

export default memo(MarketingCampaignUsageWidget);
